import moment from 'moment';
import { db, oid } from '../firebase';
import { createClient, getClients } from './clients';
import { createTimecard } from './timecards';
import { createReceipt } from './receipts';
import { createInvoice } from './invoices';
import {
  createBid,
  createBidTask,
  getBid,
  getBidTasksOnce,
  updateBidState
} from './bids';



const removeData = (paths) => {
  const promises = [];
  paths.forEach(path => {
    promises.push(db.ref(`appData/${oid}/${path}`).remove());
  });

  return Promise.all(promises);
}

const createClients = () => {
  const promises = [];
  const clients = [];
  clients.add({
    firstName: 'First',
    lastName: 'Client',
    email: 'mjmoore@gmail.com',
  });
  clients.add({
    firstName: 'Second',
    lastName: 'Client',
    email: 'mjmoore@gmail.com',
  });
  clients.add({
    firstName: 'Third',
    lastName: 'Client',
    email: 'mjmoore@gmail.com',
  });

  clients.forEach(client => {
    //createClient(client).then()
  })
}
export const generateTestData = (params, actions) => {
  //const { clients } = includes;
  const currentMoment = moment();
  const startPeriod = moment().startOf('month').subtract(4, 'months');

  const bids = new Map();

  let tmpProject;
  let tmpBidId;
  let tmpBid;
  const paths = [
    "clients", "bids", "bidTasks", "projects", "projectTasks",
    "timecards", "receipts", "invoices"
  ];

  removeData(paths)
  .then(() => {
    const client = {
      firstName: 'bob',
      lastName: 'bobberts',
      email: 'mjmoore@gmail.com',
    }

    return createClient(client);
  })
  .then(result => {
    console.log("client:", result.key);
    const clientId = result.key;

    return createBid({ clientId });
  })
  .then(result => {
    console.log("result:", result);
    const bidId = result.id;
    tmpBidId = bidId;
    const bidTask = {
      bidId,
      estimate: "100",
      title: "Simple Job Task",
      type: "simple"
    }

    return createBidTask(bidTask);
  })
  .then(result => {
    console.log("result:", result);
    console.log("id:", result.key)

    const bidState = {
      draftDate: currentMoment.valueOf(),
      sentDate: currentMoment.valueOf(),
    }

    return updateBidState(tmpBidId, bidState);
  })
  .then(() => getBid(tmpBidId))
  .then(snapshot => {
    tmpBid = { id: snapshot.key, ...snapshot.val()}
    return getBidTasksOnce()
  })
  .then(snapshot => {
    const bidTasks = [];

    snapshot.forEach((childSnapshot) => {
      const {
        id,
        bidId,
        type,
        title,
        description,
        estimate,
        monthlyAmount,
        optional,
        scheduleStart,
        scheduleFrequency,
        scheduleOccurences,
        scheduleHours,
      } = Object.assign({id: childSnapshot.key}, childSnapshot.val());

      //TODO: move to a function
      const labor = childSnapshot.val().labor !== undefined
        ? Object.entries(childSnapshot.val().labor).map(item => {
            return { id: item[0] , ...item[1]}
          })
        : []

      const materials = childSnapshot.val().materials !== undefined
        ? Object.entries(childSnapshot.val().materials).map(item => {
            return { id: item[0] , ...item[1]}
          })
        : []

      const bidTask = {
        id,
        bidId,
        type,
        title,
        description,
        estimate,
        monthlyAmount,
        optional,
        scheduleStart,
        scheduleFrequency,
        scheduleOccurences,
        scheduleHours,
        labor,
        materials
      };

      bidTask.labor.forEach((item) => {
        Object.defineProperty(item, 'total', {
          get() {
            return (this.quantity*this.rate);
          },
          configurable: true,
          enumerable: true,
        });
      });

      bidTask.materials.forEach((item) => {
        Object.defineProperty(item, 'total', {
          get() {
            return (this.quantity*this.rate);
          },
          configurable: true,
          enumerable: true,
        });
      });

      Object.defineProperty(bidTask, 'laborTotal', {
        get() {
          let total = 0;
          this.labor.forEach(function(item) {
            total += item.total;
          })

          return total;
        },
        configurable: true,
        enumerable: true,
      });

      Object.defineProperty(bidTask, 'materialsTotal', {
        get() {
          let total = 0;
          this.materials.forEach(function(item) {
            total += item.total;
          })

          return total;
        },
        configurable: true,
        enumerable: true,
      });

      Object.defineProperty(bidTask, 'subtotal', {
        get() {
          if (this.type === "estimate" || this.type === "simple") {
            return Number(this.estimate === undefined ? 0 : this.estimate);
          } else if (this.type === "maintenance") {
            return  Number(this.monthlyAmount === undefined ? 0 : this.monthlyAmount);;
          } else {
            return this.laborTotal + this.materialsTotal;
          }

        },
        configurable: true,
        enumerable: true,
      });

      //TODO: implement tax based on db setting
      Object.defineProperty(bidTask, 'gst', {
        get() {
          return this.subtotal*(0.05);
        },
        configurable: true,
        enumerable: true,
      });

      Object.defineProperty(bidTask, 'pst', {
        get() {
          return this.subtotal*(0.00);
        },
        configurable: true,
        enumerable: true,
      });

      Object.defineProperty(bidTask, 'grandTotal', {
        get() {
          return this.subtotal + this.gst + this.pst;
        },
        configurable: true,
        enumerable: true,
      });

      bidTasks.push(bidTask);
    });

    console.log("bidTasks:", bidTasks);
    return bidTasks.filter(task => task.bidId === tmpBidId );
  })
  .then(tasks => {
    console.log("tasks:", tasks);
    const addProject = actions.get("addProject");
    return addProject({}, { code: "Generated Job", ...tmpBid }, tasks);
  })
  .then(result => {
    console.log("addProject result:", result);
    tmpProject = result;

    const timecard = {
      billToClient: true,
      clientId: tmpBid.clientId,
      startDate: currentMoment.valueOf(),
      endDate: currentMoment.valueOf(),
      projectId: tmpProject.id,
    }

    return createTimecard(timecard);
  })
  .then(result => {
    console.log("tc key:", result.key);
    const receipt = {
      charged: 120,
      clientId: tmpBid.clientId,
      date: currentMoment.valueOf(),
      markupPercent: "20",
      projectId: tmpProject.id,
      tax: "10",
      total: "100",
      type: "rebill"
    }

    return createReceipt(receipt);
  })
  .then(result => {
    console.log("rc key:", result.key);
    const invoice = {
      clientId: tmpBid.clientId,
      projectId: tmpProject.id,
    }

    return createInvoice(invoice);
  })
}



// WEBPACK FOOTER //
// ./src/firebase/database/testData.js